var n = (t, i, r) => new Promise((y, s) => {
  var d = (e) => {
    try {
      o(r.next(e));
    } catch (a) {
      s(a);
    }
  }, g = (e) => {
    try {
      o(r.throw(e));
    } catch (a) {
      s(a);
    }
  }, o = (e) => e.done ? y(e.value) : Promise.resolve(e.value).then(d, g);
  o((r = r.apply(t, i)).next());
});
import { selfAxios as m } from "@oppein/op-utils";
function c(t) {
  return n(this, null, function* () {
    const {
      data: i
    } = yield m.post(
      "/designapi/design/orderStorageTime/queryOrderStorageTimeDetailByQry",
      t
    );
    return i;
  });
}
export {
  c as postQueryOrderStorageTimeDetailByQry
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designapi/design/orderStorageTime/queryOrderStorageTimeDetailByQry/post.js
// module id = 1806
// module chunks = 67